<template>
  <div>
    <svg v-if="!isImgLoaded" class="u-absolute c-img__loader">
      <use xlink:href="#icon-loader"/>
    </svg>
    <img :draggable="draggable" class="c-img" :class="[{'u-bg-blue': fakeSRC === '', 'is-loaded': fakeSRC !== ''}, 'u-fit-' + fit]" :src="fakeSRC" :alt="alt" @load="isImgLoaded = true">
  </div>
</template>

<script>
import { api } from '@/store/interfaces/apiCraft'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    src: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    margins: {
      type: Number,
      default: 500
    },
    alt: {
      type: String,
      default: ''
    },
    quality: {
      type: Number,
      default: 100
    },
    format: {
      type: String,
      default: ''
    },
    draggable: {
      type: String,
      default: "false"
    },
    fit: {
      type: String,
      default: 'cover'
    }
  },

  data () {
    return {
      currentSrc: '',
      isInViewport: false,
      isImgLoaded: false
    }
  },
  computed: {
    fakeSRC() {
      if (!this.isInViewport) {
        return ''
      }
      if (this.currentSrc !== '') {
        return this.currentSrc
      }
      if (this.src !== '') {
        return this.src
      }
      return ''
    }
  },

  created () {
    this.getImage()
  },

  mounted () {
    this.onResize()
    this.interval = setInterval(this.onResize, 1000)
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {
    async getImage () {
      const args = {id: this.id}

      if (this.width !== 0) {
        args.width = this.width
      }
      if (this.height !== 0) {
        args.height = this.height
      }
      if (this.quality !== 100) {
        args.quality = this.quality
      }
      if (this.format !== '') {
        args.format = this.format
      }

      const { cache, request } = api.imgSize(args)

      cache.then(this.treatImage)
      request.then(this.treatImage)
    },

    treatImage (img) {
      if (img === null) { return }

      // img = img.replace('$PRIMARY_SITE_URL', process.env.VUE_APP_CRAFT)
      this.currentSrc = img
      this.$emit('src', img)
    },

    onResize() {
      this.offset = this.$offset.absolute(this.$el)
      this.onScroll()
    },

    onScroll() {
      if( this.isInViewport ) { return }

      this.isInViewport = this.getIsInViewport(this.offset.top - this.margins, Infinity)
    },

    getIsInViewport(offsetTop, height) {
      if( offsetTop + height > this.$device.scroll.top && offsetTop < this.$device.scroll.top + this.$device.height ) {
        return true
      }
      else {
        return false
      }
    }
  },

  watch: {
    id () {
      this.getImage()
    },
    width () {
      this.getImage()
    },
    height () {
      this.getImage()
    }
  }
}
</script>

<style lang="stylus">
  .c-img
    opacity 0
    transform translateZ(0)
    
    &.is-loaded
      opacity 1
      transition opacity .5s

    &__loader
      top 50%
      left 50%
      transform translate(-50%, -50%)
      width 50px

</style>
